import { useState, useEffect } from 'react';

const useChipInput = ({
    initialValue = '',
    onChange,
    setValue,
    name,
    chipValues,
    allowChipModify,
    chipInputMultiple,
}) => {
    const [inputValue, setInputValue] = useState(initialValue);
    const hasChips = !!chipValues?.length;

    useEffect(() => {
        setInputValue(initialValue);
    }, [initialValue]);

    const updateValue = (newValue) => {
        setInputValue(newValue);
        onChange?.(newValue);
    };

    const clearValue = () => {
        updateValue('');
        setValue?.(name, '', { shouldValidate: true });
    };

    const handleOnChange = (e) => updateValue(e.target.value);

    const handleOnClear = (e) => {
        e.stopPropagation();
        clearValue();
    };

    const shouldModifyChip = () => inputValue && allowChipModify;

    const tryAddChip = () => {
        if (!shouldModifyChip()) return;
        allowChipModify(inputValue);
        setInputValue('');
    };

    const shouldHandleEnterKey = (e) => {
        return e.key === 'Enter' && hasChips && !chipInputMultiple;
    };

    const handleKeyPress = (e) => {
        if (!shouldHandleEnterKey(e)) {
            return false;
        }
        e.preventDefault();
        tryAddChip();
        return true;
    };

    return {
        inputValue,
        hasChips,
        handleOnChange,
        handleOnClear,
        handleKeyPress,
        tryAddChip,
    };
};


export default useChipInput;